import { render, staticRenderFns } from "./SingleInvoiceOccasion.vue?vue&type=template&id=48aba2ec&scoped=true"
import script from "./SingleInvoiceOccasion.vue?vue&type=script&lang=js"
export * from "./SingleInvoiceOccasion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aba2ec",
  null
  
)

export default component.exports